import Weapon from './weapon';

export default Weapon;
export { Weapon };